<template>
  <header>{{ title }}</header>
</template>

<script>
  export default {
    name: 'VerticalLabel',

    props: {
      title: {
        type: String,
        required: true
      }
    }

  };
</script>

<style scoped lang="scss">
    // "Handle" text is vertical
    header {
        writing-mode: tb-rl; // IE support. autoprefixer - you failed me!
        writing-mode: vertical-rl;
        text-orientation: sideways;
        flex-grow: 1;
        text-align: center; // Center top to bottom
        line-height: 30px; // Center left to right
    }
</style>



// WEBPACK FOOTER //
// src/viewer/components/VerticalLabelComponent.vue